import Gmap from "./Gmap";
import Nav from "./nav";
import Footer from "./Footer";
import Enquiry from "./Enquiry";
const Contact = () => {

    return (
        <>
            <Nav></Nav>
            <div className="news_section layout_padding" style={{ marginBottom: "2em", backgroundColor: "#F3F4F6", padding: "2rem 0" }}>
  <div className="container">
    <h1 style={{ color: "rgb(183, 110, 121)", textAlign: "center", fontWeight: "bold" }}>Contact Us</h1>
    <hr style={{ height: '3px', backgroundColor: 'rgb(183, 110, 121)', width: '18%', margin: '14px auto 30px', border: 'none' }} />

    <div className="row">

      <div className="gutter col-lg-8 col-md-8" style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)" }}>
                  
                            <Gmap></Gmap>
                        </div>
                        <div className="col-md-4">
                            <h2>Phone number</h2>
                            <p> 0122-2317323, 2317220</p>

                            <h2>E-mail</h2>
                            <p>  sbvmhapur@gmail.com</p>
                           {/*  <p>  817130223</p> */}
                        </div>
                        <div className="col-md-12">
                            <br></br>
                            <br></br>
                          
                            <Enquiry></Enquiry>

                        </div>
                    </div>

                </div>
           
                </div>
            <Footer></Footer>
        </>
    );
}
export default Contact;